(function () {
  var cards = Array.from(document.querySelectorAll('.js-fade-in'));
  if (!cards.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = cards.indexOf(entry.target);
        setTimeout(function () {
          entry.target.classList.add('visible');
        }, (idx % 3) * 80);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  cards.forEach(function (card) { observer.observe(card); });
})();
